import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Img from "../media/other.jpg"
import { motion } from "framer-motion";
import "./otherJobs.scss";

export default function PozostaleUslugi() {
  return (
    <section className="pozostale">
      <>
          <Helmet>
              <title>Pro Moto - pozostałe usługi</title>
              <meta
              name="description"
              content="PRO MOTO Oferujemy pełen zakres usług dla motocyklistów — od przechowywania,
            przez transport, po doskonalenie umiejętności jazdy. Naszym celem
            jest zapewnienie kompleksowej opieki nad Twoim motocyklem."
              />
              <link rel="canonical" href="https://promotoserwis.pl/pozostale_uslugi" />
          </Helmet>
      </>      
      <div className="pozostale-container">
        <motion.div
          className="pozostale-image"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <img
            src={Img}
            alt="Motocykl"
          />

        </motion.div>
        
        <motion.div
          className="pozostale-content"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h2>Pozostałe usługi</h2>
          <p>
            Oferujemy pełen zakres usług dla motocyklistów — od przechowywania,
            przez transport, po doskonalenie umiejętności jazdy. Naszym celem
            jest zapewnienie kompleksowej opieki nad Twoim motocyklem.
          </p>

          <ul className="pozostale-list">
            <li>
              <Link to="/transport-motocykli">Transport motocykli</Link>
            </li>
            <li>
              <Link to="/doradztwo">Doradztwo podczas zakupu</Link>
            </li>
            <li>
              <Link to="/zimowanie">Zimowanie motocykli</Link>
            </li>
            <li>
              <Link t to="/skup">Skup motocykli</Link>
            </li>
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
